<template>
    <v-container>
      <YourLink
        v-if="this.user.displayName!==null && this.user.uid!==''"
        :uid="this.user.uid"/>
            <v-row>
              <FilterAndOrder
              :hasStar="this.user.uid !== this.$route.params.id && this.user.displayName!==null"
              :hasStarOrder="this.$route.params.id !==undefined"
              @change="filterChanged"/>
            </v-row>
            <v-row
                v-for="(movie, i) in movies"
                :key="i"
                >
                  <v-card v-if="movie.ad" class="mx-auto" outlined width="80%" max-width="500">
                    <v-card-text>
                        <Advertising />
                    </v-card-text>
                  </v-card>
                  <v-card v-else class="mx-auto" outlined width="80%" max-width="500">
                    <v-toolbar dense flat
                      color="white"
                    >
                    <v-spacer></v-spacer>
                    <v-menu v-if="movie.isYours" bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="removeMeThis(movie.URL)">
                          <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                          <v-list-item-content>Apagar</v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          @click="reviewThis(movie.URL)">
                            <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                            <v-list-item-content>Editar</v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    </v-toolbar>
                    <v-img contain max-height="200px" :src="movie.imagem"></v-img>
                    <v-card-title>
                      {{movie.name}}
                    </v-card-title>
                    <v-card-subtitle v-text="movie.type"></v-card-subtitle>
                    <v-card-actions>
                    <a target="_blank" :href="movie.URL" >Assista no {{movie.site}}</a>
                    </v-card-actions>
                    <v-card shaped elevation="5" width="99%"
                      color="#ffffcc"
                      v-if="movie.userDescription && movie.userDescription.length > 0">
                        <v-card-subtitle>{{movie.userName}} disse:</v-card-subtitle>
                        <v-card-text>{{movie.userDescription}}</v-card-text>
                      </v-card>
                      <v-container>
                            <v-row>
                              <v-badge
                                label="Rattings"
                                color="blue"
                                inline
                                :value="movie.UsersRate.count"
                                :content="movie.UsersRate.count">Avaliações</v-badge>
                            </v-row>
                             <v-row v-for="(userrate) in movie.UsersRate.rates"
                              :key="userrate.id">
                              <v-col v-if="userrate.id !== user.uid">
                                {{userrate.name}}
                              </v-col>
                              <v-col v-else>
                                Você:
                              </v-col>
                              <v-col>
                                <v-rating
                                v-if="userrate.id !== user.uid"
                                v-model="userrate.rate"
                                half-increments
                                readonly>
                                </v-rating>
                                <v-rating
                                  v-else-if="userrate.rate !== -1"
                                  v-model="userrate.rate"
                                  color="yellow"
                                  readonly>
                                </v-rating>
                                <v-btn
                                  v-else-if="user.displayName !== null"
                                  color="blue"
                                  block
                                  @click="reviewThis(movie.URL)">
                                    Avalie Você
                                </v-btn>
                                <v-container v-else>
                                  Para avaliar também, faça seu login
                                </v-container>
                              </v-col>
                             </v-row>
                      </v-container>
                      </v-card>
            </v-row>
            <v-row>
              <v-card
              class="mx-auto"
              outlined
              width="80%"
              max-width="500"
              v-if="user.displayName!=null">
                <v-btn color="blue" block @click="addReview()">Avaliar outros</v-btn>
              </v-card>
            </v-row>
    </v-container>
</template>
<script>
import YourLink from './YourLink.vue';
import Advertising from './Advertising.vue';
import FilterAndOrder from './FilterAndOrder.vue';

export default {
  name: 'Movies',
  data() {
    return {
      url: '',
      movie: null,
      movies: [],
      userrate: {
        id: '',
        name: '',
        rate: 0,
      },
      user: { uid: '', displayName: '', photoURL: '' },
      filter: {
        order: 'date',
        series: true,
        movies:
        true,
        rated: true,
      },
    };
  },
  components: {
    YourLink,
    Advertising,
    FilterAndOrder,
  },
  created() {
    this.$auth.onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
        // if (user.displayName == null) this.readMoviesFromFirestore(this.filter);
      }
    });
  },
  mounted() {
    setTimeout(() => {
      if (!this.$route.params.id) {
        console.log('aquii');
        this.filterChanged(this.filter);
      }
    }, 1000);
  },
  methods: {
    filterChanged(filter) {
      console.log(JSON.stringify(filter));
      this.filter = filter;
      this.readMoviesFromFirestore(filter);
      setTimeout(() => {
        this.anonimousauth();
      }, 1000);
    },
    anonimousauth() {
      if (this.user.uid === '') {
        this.$auth.signInAnonymously().catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error('Erro na autenticação anonima', errorCode, errorMessage);
        });
      }
    },
    readMoviesFromFirestore(filter) {
      const db = this.$firebase.firestore();
      this.movies = [];
      let hasAd = false;
      let position = 0;
      const adInterval = 10;
      let orderby = `UsersRate.${this.$route.params.id}.${filter.order}`;
      if (this.$route.params.id === undefined) {
        orderby = 'UsersRate';
      }
      const firebaseFiltered = db.collection('Movie').orderBy(orderby, 'desc').limit(30);
      firebaseFiltered.get()
        .then((docs) => {
          docs.forEach((doc) => {
            const movie = doc.data();
            if (this.applyFilter(filter, movie)) {
              position += 1;
              movie.icon = movie.imagem;
              if (this.$route.params.id) {
                movie.userDescription = movie.UsersRate[this.$route.params.id].description;
                movie.userName = movie.UsersRate[this.$route.params.id].name;
                if (this.user.uid === this.$route.params.id) movie.userName = 'Você';
              }
              if (movie.UsersRate[this.user.uid] !== undefined) movie.isYours = true;
              movie.UsersRate = this.calculatemovieratestats(
                movie.UsersRate, this.$route.params.id,
              );
              if (position % adInterval === 0) {
                this.movies.push({ ad: true });
                hasAd = true;
              }
              this.movies.push(movie);
            }
          });
          if (!hasAd) {
            this.movies.push({ ad: true });
          }
        },
        (err) => {
          console.log(err);
        });
    },
    applyFilter(filter, movie) {
      if (!filter.series && movie.type === 'TVSeries') return false;
      if (!filter.movies && movie.type === 'Movie') return false;
      if (!filter.rated && movie.UsersRate[this.user.uid]) return false;
      return true;
    },
    addReview() {
      this.$router.push('/add');
    },
    reviewThis(url) {
      this.$router.push(`/add/${btoa(url)}`);
    },
    removeMeThis(url) {
      const db = this.$firebase.firestore();
      const Movieid = url.replace(/\//g, '');
      const ref = db.collection('Movie').doc(Movieid);
      const unsubscribe = ref.onSnapshot((docs) => {
        if (docs.data() !== undefined) {
          const movie = docs.data();
          delete movie.UsersRate[this.user.uid];
          db.collection('Movie').doc(Movieid).set(movie);
          this.movies.splice(this.movies.findIndex((m) => m.URL === url), 1);
        }
        unsubscribe();
      },
      (err) => {
        console.log(err);
      });
    },
    calculatemovieratestats(usersrate, routeuid) {
      const newUsersRate = { count: 0, rates: [] };
      let sumOfRates = 0;
      // eslint-disable-next-line
      for (const uid in usersrate) {
        if (routeuid === uid || this.user.uid === uid) newUsersRate.rates.push(usersrate[uid]);
        newUsersRate.count += 1;
        sumOfRates += usersrate[uid].rate;
      }
      if (usersrate[this.user.uid] === undefined) newUsersRate.rates.push({ name: 'You', rate: -1, id: this.user.uid });
      const average = sumOfRates / newUsersRate.count;
      newUsersRate.rates.push({ name: 'Média', rate: average, uid: '1' });
      return newUsersRate;
    },

  },
};
</script>
